import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginLeft: '80px',

      [THEME.media.medium]: {
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 0,
      },
    },
  },
};

export const CENTER: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 0,
    },
  },
};
